<template>
  <div class="full__container">
    <prismic-image
      :field="slice.primary.full_image"
      v-if="slice.primary.full_image"
    />
    <div class="dida" v-if="slice.primary.dida">
      {{ slice.primary.dida }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    slice: Object,
  },
};
</script>

<style lang="scss" scoped>
.full__container{
    margin: 100px 0;
    width: 100%;
}

.dida{
  margin: 20px 24vw;
  font-family: Lausanne, Arial, Helvetica, sans-serif;
  font-size: 16px;
  text-transform: uppercase;
    @media screen and (max-width: 767px) {
    margin: 20px 32px;
    font-size: 14px;
  }
}
</style>
